import React, { useEffect } from "react";
import "./App.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Router from "./Router";
import Preloader from "./components/Preloader";
import { InitialLoader } from "./components/ActoLoan/InitialLoader";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const App = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
    <InitialLoader />
    <Router />
    <ToastContainer />
    </>
  );
};

export default App;
